// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-bvdb","image":"styles_image__UicKA","cursor":"styles_cursor__VZGgU","cursorMove":"styles_cursorMove__DNh2V"};